import styled from 'styled-components';

export const PatientCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 335px;
  margin: 0 auto;
  @media (max-width: 330px) {
    width: 300px;
  }
`;

export const PatientCardHeader = styled.div`
  background: ${(props) => props.theme.palette.primary.contrastText};
  margin-top: 24px;
  padding: 10px 20px;
  border: 1px solid ${(props) => props.theme.palette.darkTransparency};
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
`;

export const PatientCardHeaderText = styled.div`
  margin: 5px 0px 0px;
  padding: 10px 0px 15px;
  border-bottom: 1px solid ${(props) => props.theme.palette.darkTransparency};
`;

export const PatientCardHeaderTextSecond = styled.div`
  margin: 5px 0px 0px;
  padding: 10px 0px 15px;
  display: flex;
  img {
    margin: 0px 10px 0px 0px;
  }
`;

export const PatientCardInfos = styled.div`
  font-size: 14px;
  color: ${(props) =>
    props.colorDark ? props.theme.palette.gray3 : props.theme.palette.gray1};
`;

export const PatientCardInfosSpan = styled.span`
  color: ${(props) =>
    props.colorDark ? props.theme.palette.gray3 : props.theme.palette.gray1};
  font-size: ${(props) => (props.fontSizeLarger ? '16px' : '14px')};
  font-weight: ${(props) => (props.fontWeightLarger ? '600' : '500')};
  margin: 0px 2px;
`;

export const PatientCardInfosSecond = styled.div``;

export const UnblockerButton = styled.button`
  display: flex;
  margin: 16px 0 0px 0;
  padding-top: 8px;
  padding-bottom: 8px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  background-color: #f7f7fa;
  cursor: pointer;
  border: 1px dashed #8a9eb5;
  border-radius: 6px;
  user-select: none;
  width: 335px;
  height: 50px;

  &:active {
    opacity: 0.3;
  }
  @media (max-width: 330px) {
    width: 300px;
  }
`;

export const UnblockerButtonLabel = styled.span`
  margin-left: 10px;
  font-size: 16px;
  color: #78849e;
  opacity: 1;
  font-family: 'Rubik';
`;
